import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'

import * as styles from './styles'

const MobileProfileHeaderComponent = ({
	title = 'Profile',
	activeTab = 'account',
	onTabChange,
}) => {
	const tabs = [
		{ id: 'account', label: 'Account' },
		{ id: 'info', label: 'Info' }
	]

	return (
		<div css={styles.headerContainer}>
			{/* Header */}
			<div css={styles.header}>
				<div css={styles.logoAndTitleContainer}>
					<img
						src="./img/inwin-tiny-white-logo.png"
						alt="InWin Logo"
						css={styles.logoImage}
					/>
					<Text size={20} bold css={styles.title}>
						{title}
					</Text>
				</div>
			</div>

			{/* Tabs */}
			<div css={styles.tabsContainer}>
				<div css={styles.tabsWrapper}>
					{tabs.map((tab) => (
						<button
							key={tab.id}
							css={[
								styles.tab,
								activeTab === tab.id && styles.activeTab
							]}
							onClick={() => onTabChange(tab.id)}
							type="button"
						>
							<Text
								size={12}
								bold={activeTab === tab.id}
								css={[
									styles.tabText,
									activeTab === tab.id && styles.activeTabText
								]}
							>
								{tab.label}
							</Text>
						</button>
					))}
				</div>
			</div>
		</div>
	)
}

MobileProfileHeaderComponent.propTypes = {
	title: PropTypes.string,
	activeTab: PropTypes.string,
	onTabChange: PropTypes.func.isRequired,
}

export default MobileProfileHeaderComponent 